module.exports = __webpack_public_path__ + "static/media/img-top-right.8374594a.png";